import React from 'react';

export default function StatsBlockConfig({ data, onChange }) {
  const stats = data.stats || [];

  const updateStat = (index, field, value) => {
    const newStats = [...stats];
    newStats[index] = { ...newStats[index], [field]: value };
    onChange({ ...data, stats: newStats });
  };

  const addStat = () => {
    onChange({ ...data, stats: [...stats, { number: '', label: '' }] });
  };

  const removeStat = (index) => {
    onChange({ ...data, stats: stats.filter((_, i) => i !== index) });
  };

  return (
    <>
      <div className="adminblog-field">
        <label>Stats ({stats.length})</label>
        {stats.map((stat, i) => (
          <div key={i} className="adminblog-list-item">
            <input type="text" value={stat.number} onChange={(e) => updateStat(i, 'number', e.target.value)} placeholder="72%" style={{ maxWidth: 80 }} />
            <input type="text" value={stat.label} onChange={(e) => updateStat(i, 'label', e.target.value)} placeholder="Label description" />
            <button className="adminblog-list-remove" onClick={() => removeStat(i)}>×</button>
          </div>
        ))}
        <button className="adminblog-list-add" onClick={addStat}>+ Add Stat</button>
      </div>
    </>
  );
}
